module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "66vh"
    }
  }, [_c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 align-self-center fadeIn animated"
  }, [_c('div', {
    staticClass: "banner-text"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.text.title))]), _vm._v(" "), _c('p', {
    staticClass: "py-3 text-line"
  }, [_vm._v("\n                      " + _vm._s(_vm.text.content) + "\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 px-0"
  }, [_c('div', {
    staticClass: "banner-bg"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f7ae116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 32
// module chunks = 0